import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {gsap, TimelineMax} from "gsap";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";
import {TrueGritSound} from "../../sound/TrueGritSound";

/**
 * Created by Jerker Nord on 2021-10-26.
 */

export class TrueGritReelSplitRunner implements SimplePresentation {

    private _mainTL:TimelineMax;

    shouldRun():boolean {
        if(TrueGrit.model.gameData.xSplits) {
            return true;
        }
        return false;
    }

    start(controller:SimplePresentationRunnerController):void {
        let symbol:TrueGritSymbol;
        const longZReel:string[] = TrueGrit.model.reelSplitLongReel;
        const reelSplits:string[][] = [];
        const reelSplitZPositions:number[] = [];

        while(longZReel.includes("Z")) {
            let tempPosition:number = 0;
            let zFound:boolean = false;
            for(let i:number = 0; i < 3; i++) {
                if(longZReel[i] == "Z" && TrueGrit.model.gameData.botTrain.isRevealed[i] == true) {
                    zFound = true;
                    tempPosition = i;
                    reelSplits.push(longZReel.slice(0, 3));
                    break;
                }
            }
            if(zFound == true) {
                reelSplitZPositions.push(tempPosition);
                longZReel.splice(tempPosition, 1);
            }
        }

        this._mainTL = gsap.timeline({onComplete : controller.finish});
        let zPosition:number = 0;
        for(let i:number = 0; i < reelSplits.length; i++) {
            //If more than one Z, we need an delay to wait for the fill up from previous to finish
            let delay:number = 0;
            if(i > 0) {
                delay = 0.25;
            }
            const splitReelTL:TimelineLite = gsap.timeline({delay : delay});

            // #477 -> safe check
            const allUsedScattersLength: number = TrueGrit.trueGritScatterSymbols.getAllUsedScatters().length;
            if (allUsedScattersLength > 0) {
                splitReelTL.add(() => TrueGrit.bottomReelView.startHotZoneAnimation(allUsedScattersLength - 1));
            }

            splitReelTL.add(() => {zPosition = reelSplitZPositions[i]});
            splitReelTL.add([
                () => {TrueGrit.reelSplitView.getReelSplitAnimation((<TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(zPosition + 1)).position)},
                () => {TrueGrit.soundPlayer.playSound(TrueGritSound.REEL_SPLIT_SOUND)}
            ]);
            splitReelTL.add(() => {}, "+=0.4");
            //2. Split all symbols on reel animations
            splitReelTL.add(() => {
                for(let k:number = 3; k > 0; k--) {
                    (<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[zPosition + 2].reelView.getSymbol(k)).getSplitAnimation((<TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[zPosition + 2].reelView.getSymbol(k)).splitLevel + TrueGrit.model.gameData.xSplits.splitSize);
                }
            });
            //Remove Z symbol
            splitReelTL.add(() => {symbol = <TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(zPosition + 1)}, "+=0.5");
            splitReelTL.add(() => {symbol.isRemoved = true});
            splitReelTL.add(() => TrueGrit.allReelsView.bottomReelModel.reelView.removeAvalancheSymbol(symbol));
            splitReelTL.add(() => {TrueGrit.waysView.updateNumberOfWays()});

            //Collapse bottom reel
            splitReelTL.add(() => {TrueGrit.allReelsView.bottomReelModel.collapseReel()});

            //Fill up bottom reel
            let collapseDelay:number = 0.2;
            if(reelSplitZPositions[i] == 2) {
                //No collapse delay if Z is on position 3
                delay = 0;
            }
            splitReelTL.add(() => {TrueGrit.allReelsView.bottomReelModel.getFillUpReelAnimation(reelSplits[i + 1])}, "+=" + collapseDelay);
            splitReelTL.add(() => {}, "+=0.35");

            this._mainTL.add(splitReelTL);
        }
        if(reelSplits.length > 1 || reelSplits.length == 1 && reelSplitZPositions[0] == 2) {
            //All done, need delay so last fill up has time to finish
            this._mainTL.add(() => {}, "+=0.25");
        }

        if(this._mainTL.duration() == 0) {
            this._mainTL.add(gsap.to(this, {duration : 0.001}));
        }
    }
}